import type { Lang } from "@noli/core";
import { langDescriptions, langStore, translate, updateDictionary } from "@noli/business";
import { editorGalleryLangRecords, editorLangRecords, editorAlbumLangRecords } from "./editor";
import { loginLangRecords } from "./login";
import { toastLangRecords } from "./toast";
import { recommendationDictionary } from "../constants";
import { paramsRecords } from "./aiParams";
import { albumLangRecords } from "./album";
import { userAssetsLangRecord } from "./userAsset";
import { allThirdPartyLangRecords } from "@/thirdParty/lang";
import { captchaLangRecords } from "./captcha";
import { projectLangRecords } from "./project";

export { Editor_Words as Words, Editor_Gallery_Words, Editor_Album_Words } from "./editor";
export { Login_Words } from "./login";
export { Toast_Words } from "./toast";
export { AI_Params_Words } from "./aiParams";
export { Captcha_Words } from "./captcha";
export { Project_Words } from "./project";

const initLangDirs = [
  paramsRecords,
  userAssetsLangRecord,
  toastLangRecords,
  editorLangRecords,
  loginLangRecords,
  recommendationDictionary,
  editorGalleryLangRecords,
  albumLangRecords,
  editorAlbumLangRecords,
  captchaLangRecords,
  projectLangRecords,
  ...allThirdPartyLangRecords,
];

export function initializeLang(): void {
  for (const lang of Object.keys(langDescriptions) as Lang[]) {
    initLangDirs.forEach((d) => updateDictionary(lang, d[lang]));
  }
}

export function getBrowserLang() {
  return navigator.language;
}

export function isZh() {
  return langStore.tgt === "zh";
}

export function isEn() {
  return langStore.tgt === "en";
}

// 在使用的地方还是需要 observer, 因为内部用到了 langStore
export function useTranslate() {
  const lang = langStore.tgt;

  function _translate(key: string) {
    return translate(key, lang);
  }

  return {
    translate: _translate,
  };
}
